module.exports = __webpack_public_path__ + "img/06.96f3b217.jpg";